import { render, staticRenderFns } from "./FilterWallet.vue?vue&type=template&id=439b93a9&scoped=true&"
import script from "./FilterWallet.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FilterWallet.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439b93a9",
  null
  
)

export default component.exports